import { Card, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const NoResultsBanner = () => {
  const { t } = useTranslation();

  return (
    <Card
      variant="default"
      sx={{
        borderRadius: 0,
        textAlign: 'center',
      }}
    >
      <Typography variant="body1">{t('publicSearch.no_results')}</Typography>
    </Card>
  );
};
